import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, throwError, Observable } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

// INTERFACES
import { IApprovalRule } from '../../../../approval/interfaces';
import { IPagination } from '../../../interfaces/paginator.interface';

// SERVICES
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ApprovalModelApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getAllModelFields() :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/approval-models/all-fields`,
    );
  }

  getModelFields(model :string) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/approval-models/all-fields/${model}/fields`,
    );
  }
}
